import {
  LocationType,
  useHistory,
  useQueryParamsCallback,
} from '@aboutyou/router';
import {sortIdToSortType, useTrackFilter} from '@aboutyou/tracking';
import {getUpdatedFilterParams} from './getUpdatedFilterParams';
import {FilterObjForBulkTracking} from './usePotentialFilters';

type SortingOptions = {
  shouldScrollToTop?: boolean;
  shouldTrackImmediately?: boolean;
  addFilterForBulkTracking?: (filterObj: FilterObjForBulkTracking) => void;
};

export const useSorting = (): {
  setSorting: (value: string, options?: SortingOptions) => void;
  sorting: string | undefined;
} => {
  const history = useHistory();
  const getQueryData = useQueryParamsCallback();
  const filterTracker = useTrackFilter();

  const setSorting = (value: string, options?: SortingOptions) => {
    const {
      addFilterForBulkTracking,
      shouldScrollToTop,
      shouldTrackImmediately = true,
    } = options ?? {};
    const filterObj: FilterObjForBulkTracking = {
      section: 'sort',
      slug: [sortIdToSortType(value)],
      type: 'attribute',
      action: 'submit',
      label: 'filter_modal',
    };
    if (shouldTrackImmediately) {
      filterTracker(
        filterObj.section,
        filterObj.slug,
        filterObj.type,
        filterObj.action,
        filterObj.label,
      );
    } else {
      addFilterForBulkTracking && addFilterForBulkTracking(filterObj);
    }

    const historyOject: LocationType = {
      state: {
        ...((history.location?.state as LocationType['state']) ?? {}),
        isSorting: true,
      },
      search: getUpdatedFilterParams({
        search: getQueryData().toString(),
        update: new Map([['sort', [value]]]),
      }),
    };

    if (shouldScrollToTop) {
      history.replaceWithScrollTopAnchor(historyOject);
    } else {
      history.replace(historyOject);
    }
  };

  return {
    setSorting,
    sorting: getQueryData().get('sort')?.toString() ?? undefined,
  };
};
